import React, { useContext } from 'react';

// Hooks
import { useTranslation } from 'Shared/contexts/TranslationsContext';
import { useApp } from 'Shared/utils/hooks/use-app';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useOrganization } from 'Shared/utils/hooks/use-organization';
// Components
import { WpIcon } from 'Wpds/components/icon';
import { WpLink } from 'Wpds/components/link';
import { WpPopover, WpPopoverContent, WpPopoverToggle } from 'Wpds/components/popover';
import { WpText } from 'Wpds/components/text';

// Context
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';

// Styles
import './ThirdPartyUserIndicator.scss';

/**
 * A component which contains the link to PI from PI Perform built for the
 * SideNavigation component.
 */
const ThirdPartyUserIndicator = () => {
  const isExpanded = useContext(ExpandNavbarContext);
  const { piAppUrl } = useApp();
  const { isThirdPartyUser: currentUserIsThirdParty } = useCurrentUser();
  const { organization } = useOrganization();
  const { tr } = useTranslation();

  if (!isExpanded) return null;
  if (!currentUserIsThirdParty) return null;

  const baseClassName = 'ThirdPartyUserIndicator';

  return (
    <WpPopover placement="right-start" event="hover" maxWidth="300px">
      <WpPopoverToggle>
        <div className={baseClassName}>
          <div className={`${baseClassName}__header`}>
            <WpText noMargin bold={true}>
              {tr('perform.navigation.third_party_user_indicator.company_label')}
            </WpText>
            <WpLink href={piAppUrl} target="_self" className={`${baseClassName}__header__link`}>
              <WpIcon name="external-link" size="sm" />
              {tr('perform.navigation.third_party_user_indicator.switch_link')}
            </WpLink>
          </div>
          <WpText noMargin>{organization.name}</WpText>
        </div>
      </WpPopoverToggle>
      <WpPopoverContent>
        <WpText bold>{tr('perform.navigation.third_party_user_indicator.switch_companies_title')}</WpText>
        <WpText noMargin>{tr('perform.navigation.third_party_user_indicator.switch_companies_instructions')}</WpText>
      </WpPopoverContent>
    </WpPopover>
  );
};

export default React.memo(ThirdPartyUserIndicator);
